var map = {
	"./en/Partners_Karavidas": [
		"8604",
		"chunk-51fa9c88"
	],
	"./gr/Partners_Karavidas": [
		"98b5",
		"chunk-ac3c919a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d09e";
module.exports = webpackAsyncContext;